import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
    avatar: '',
    userName: '',
    email: '',
    authority: [],
    isConnectedPartner: true,
}

export const userSlice = createSlice({
    name: 'auth/user',
    initialState,
    reducers: {
        setUser: (state, action) => { 
            return {
                ...initialState,
                ...action.payload
            }
        },
        setIsConnectedPartner: (state, action) => {
            state.isConnectedPartner = action.payload;
        },
        userLoggedOut: () => initialState,
    },
})

export const { setUser, setIsConnectedPartner } = userSlice.actions

export default userSlice.reducer
